import iconCheck from '@fnacdarty/fnac-icons/svg/check.svg?svgref';
import iconHTML from '../../helpers/html/icon.js';
import iconHeartFill from '@fnacdarty/fnac-icons/svg/heart+fill.svg?svgref';
import { isMobile } from '../../configuration/Configuration.js';
import translation from '../../helpers/translation/translation.js';

/** Template pour la popin Wishlist */
export const wishlistPopinTemplate = `<div class="f-wishlist-dialog ff-modal" data-automation-id="wishlist-popin-block">
  <div class="f-wishlist-dialog__container js-addtoWishlist-container">
    <!-- choices, complete or notIdentified will be there, replace all other child nodes -->
  </div>
</div>`;

/**
 * Template pour les choix de la wishlist
 *
 * @returns {string} Le HTML généré
 */
export const renderWishlistDialogChoices = () => {
  return `
<h1 class="f-wishlist-dialog__title" data-automation-id="wishlist-popin-list">
  ${translation('core.wishlist.layout.title')}<span class="f-wishlist-dialog__list-count js-f-wishlist-dialog-count">(0)</span>
</h1>

<form class="f-wishlist-dialog__content js-f-wishlist-dialog-form" id="WishlistForm">
  <div class="f-wishlist-dialog__list js-f-wishlist-dialog-list">
    <!-- checkbox are generated async and will be appended right here -->
  </div>
</form>

<form class="js-f-wishlist-dialog-form">
  <div class="f-wishlist-dialog__add-fieldset">
    <!-- can't use fieldset and flex <legend class="f-wishlist-dialog__add-fieldset-legend">${translation('core.wishlist.layout.title2')}'</legend> -->
    <input type="text" data-automation-id="wishlist-popin-input-name" name="wishlist_name" class="f-wishlist-dialog__add-input" placeholder="${translation('core.wishlist.layout.title2')}" required />
      <button type="submit" data-automation-id="wishlist-popin-btn-new" name="wishlist_add_btn" class="ff-button ff-button--dark ff-button--outline">${translation('wishlist.popinheader.button.create')}</button>
  </div>
</form>

<button form="WishlistForm" type="submit" class="ff-button ff-button--orange" data-automation-id="add-to-wishlist-button">
  <!-- submit by Id form -->
  ${iconHTML(iconHeartFill, {
    className: 'ff-button-icon',
  })}
  <span class="ff-button-label">${translation('wishlist.popinheader.button.addtowishlist')}</span>
</button>
`;
};

/**
 * Template pour l'affichage quand l'utilisateur n'est pas connecté
 *
 * @param {string} signInURL URL de retour sur la page courante
 * @returns {string} Le HTML généré
 */
export const renderWishlistPopinNotLogged = (signInURL) => {
  return `
    <h1 class="f-wishlist-dialog__title">${translation('core.wishlist.layout.title')}</h1>
    <div class="f-wishlist-dialog__content">
      <div class="f-wishlist-dialog__general-msg">
        ${translation('core.wishlist.layout.message')}
      </div>
      <a href="${signInURL}"
          class="ff-button ff-button--orange"
          arial-label="${translation('mobile.fa.popin.wishlist.authentybuttontext')}">${translation('mobile.fa.popin.wishlist.authentybuttontext')}</a>
    </div>`;
};

/**
 * Template pour la confirmation d'ajout à la wishlist
 *
 * @param {string} myAccountWishlistURL URL de la wishlist dans mon compte
 * @returns {string} Le HTML généré
 */
export const renderWishlistPopinConfirmation = (myAccountWishlistURL) => {
  return `
    <div class="f-wishlist-dialog__content">
      <div class="f-wishlist-dialog__general-msg">
        ${iconHTML(iconCheck, {
          className: 'f-wishlist-dialog__general-msg-icon',
        })}
        ${translation('wishlist.popinheader.confirm')}
      </div>

      <a href="${myAccountWishlistURL}" class="ff-button ff-button--dark ff-button--outline" aria-label="${translation('mobile.account.nav.wishlist')}">${translation('mobile.account.nav.wishlist')}</a>
    </div>`;
};

/**
 * Template pour les items de la wishlist
 *
 * @param {object} data Données contenant les items de la wishlist
 * @returns {string} Le HTML généré
 */
export const renderWishlistPopinItems = (data) => {
  const { wishlistItems } = data;
  return wishlistItems
    .map(
      (wishlistItem) => `
  <div class="f-wishlist-dialog__li">
    <input type="radio" name="wishlists" class="${isMobile ? 'f-radio' : 'f-wishlist-dialog__li-input'}" value="${wishlistItem.id}"${wishlistItem.selected ? ' checked' : ''} id="wishlist-${wishlistItem.id}">
    <label class="f-wishlist-dialog__li-label" for="wishlist-${wishlistItem.id}">
      ${wishlistItem.name}
      <span class="f-wishlist-dialog__li-count">(${wishlistItem.numberOfItems})</span>
    </label>
  </div>
  `
    )
    .join('');
};
